__turbopack_context__.v({
  "mobileWrapper": "styles-module-scss-module__Z1bTHG__mobileWrapper",
});
